export const PAYMENT_SUCCESS_FOOTER = {
    DONE_BTN: "done-btn",
    VIEW_HELP: "view-help",
    HELP_BTN: "view-help-btn",
    CASHBACK_CALLOUT: "cashback-callout",
};
